import { create, tsx } from '@dojo/framework/core/vdom';
import Link from '@dojo/framework/routing/Link';
import * as css from './LearnMore.m.css';

export interface LearnMoreProperties {
	title: string;
	content: string;
	link: string;
}

const factory = create().properties<LearnMoreProperties>();

export const LearnMore = factory(function LearnMore({ properties }) {
	const { title, content, link } = properties();
	return (
		<div classes={css.root}>
			<h2 classes={css.title}>{title}</h2>
			<div classes={css.content}>{content}</div>
			<Link classes={['headerSubmenuLink', css.button]} to={link} tabIndex={0}>
				Learn More
			</Link>
		</div>
	);
});

export default LearnMore;
